/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CompanyPaymentMethodVerificationStatus {
  Verified = "Verified",
  PendingVerification = "PendingVerification",
}

export function instanceOfCompanyPaymentMethodVerificationStatus(
  value: any,
): boolean {
  for (const key in CompanyPaymentMethodVerificationStatus) {
    if (
      Object.prototype.hasOwnProperty.call(
        CompanyPaymentMethodVerificationStatus,
        key,
      )
    ) {
      if (
        CompanyPaymentMethodVerificationStatus[
          key as keyof typeof CompanyPaymentMethodVerificationStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CompanyPaymentMethodVerificationStatusFromJSON(
  json: any,
): CompanyPaymentMethodVerificationStatus {
  return CompanyPaymentMethodVerificationStatusFromJSONTyped(json, false);
}

export function CompanyPaymentMethodVerificationStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyPaymentMethodVerificationStatus {
  return json as CompanyPaymentMethodVerificationStatus;
}

export function CompanyPaymentMethodVerificationStatusToJSON(
  value?: CompanyPaymentMethodVerificationStatus | null,
): any {
  return value as any;
}

export function CompanyPaymentMethodVerificationStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CompanyPaymentMethodVerificationStatus {
  return value as CompanyPaymentMethodVerificationStatus;
}
